import { useRecoilValue } from "recoil";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import dayjs from "dayjs";
import { authState } from "@/comn/features/recoil";
import { Icon, Button } from "@/comn/components";
import { useLogin } from "@/comn/features/authentication/useLogin";
import { useEffect, useState } from "react";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

export const NavigationInfoOpened = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { isInitialized, isSignedIn, userInfo, signedAt, coUsrYn } = useRecoilValue(authState);
    const { handleLogin, handleCompany, handleCustom, logout, handleRegist } = useLogin();
    const [authTpNm, setAuthTpNm] = useState("");

    const handler = {
        getCGM0167: async () => {
            const { data } = await api.get(
                `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/comnppup/comn-cd/CGM0167/${userInfo.authTpCd}`,
            );
            const { comnCd } = data;

            setAuthTpNm(comnCd.content.cdVldValNm);
        },
    };

    useEffect(() => {
        userInfo.lgnTp === "ANY" && !comnUtils.isEmpty(userInfo.authTpCd) && handler.getCGM0167();
    }, [userInfo.authTpCd]);

    return (
        <div className="relative bg-primary h-[240px] rounded-t-[24px] rounded-br-[48px]">
            {/* Img-map */}
            <div className="absolute w-full h-full top-0 left-0 overflow-hidden rounded-tl-[24px]">
                <img
                    className="absolute top-0 left-0 -translate-x-1/4 -translate-y-1/4 -scale-x-[1] opacity-30"
                    src={process.env.PUBLIC_URL + "/imgs/bg-map.svg"}
                    alt="login background image map"
                    title="login background image ship"
                    width={389}
                    height={242}
                />
            </div>

            {/* Pending */}
            {!isInitialized && (
                <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                    <Icon icon="loading" className="animate-spin" />
                </div>
            )}

            {isInitialized && isSignedIn && (
                <>
                    {/* Img-ship */}
                    <img
                        className="absolute top-0 right-0 -translate-x-1/4 -translate-y-1/3"
                        src={process.env.PUBLIC_URL + "/imgs/img_ship.svg"}
                        alt="login background image ship"
                        title="login background image ship"
                        width={250 / 3}
                        height={178 / 3}
                    />
                    {/* Signout Button */}
                    <button
                        type="button"
                        className="absolute top-8 right-6 bg-black/10 p-2 rounded-full transition hover:bg-white/30"
                        onClick={logout}
                    >
                        <Icon className="text-primary-contrast" size="sm" icon="logout" />
                    </button>

                    <div className="absolute w-full p-4 left-0 top-[60px]">
                        <ul
                            className={classNames(
                                "flex flex-col gap-1 pr-2 text-primary-contrast",
                                "[&>li]:h-6 [&>li]:flex [&>li]:items-center [&>li]:justify-between",
                            )}
                        >
                            {userInfo?.lgnTp !== "INT" && (
                                <li>
                                    <span>TIN</span>
                                    {userInfo?.tin}
                                </li>
                            )}
                            <li>
                                <span>
                                    {process.env.REACT_APP_SYSTEM_GROUP === "tancis"
                                        ? t("L_USR_DMN_ID")
                                        : t("L_USR_ID")}
                                </span>
                                {userInfo?.usrId}
                            </li>
                            <li>
                                <span>{t("L_NAME")}</span>
                                {userInfo.lgnTp == "LCM" ? userInfo?.coNm : userInfo?.usrNm}
                            </li>
                            {(coUsrYn === "Y" || userInfo.lgnTp == "OGA") && userInfo?.coTpList && (
                                <li className="relative">
                                    <span>{t("L_CO_CD")}</span>
                                    {userInfo?.coTpList.length > 1 ? (
                                        <button
                                            type="button"
                                            className="absolute right-0 rounded bg-black/10 px-2 h-full transition hover:bg-white/30"
                                            onClick={handleCompany}
                                        >
                                            {userInfo?.coDclaCd}
                                        </button>
                                    ) : (
                                        <span> {userInfo?.coDclaCd} </span>
                                    )}
                                </li>
                            )}
                            {process.env.REACT_APP_SYSTEM_GROUP === "tancis" && userInfo?.cstmCd && (
                                <li className="relative">
                                    <span>{t("L_CSTM")}</span>
                                    {userInfo?.usrCstmList && userInfo?.usrCstmList.length > 1 ? (
                                        <button
                                            type="button"
                                            className="absolute right-0 rounded bg-black/10 px-2 h-full transition hover:bg-white/30"
                                            onClick={handleCustom}
                                        >
                                            {userInfo?.cstmCd}
                                        </button>
                                    ) : (
                                        <span> {userInfo?.cstmCd} </span>
                                    )}
                                </li>
                            )}
                        </ul>
                    </div>
                </>
            )}

            {isInitialized && !isSignedIn && userInfo.lgnTp === "ANY" && (
                <>
                    {/* Img-ship */}
                    <img
                        className="absolute top-0 right-0 -translate-x-1/4 -translate-y-1/3"
                        src={process.env.PUBLIC_URL + "/imgs/img_ship.svg"}
                        alt="login background image ship"
                        title="login background image ship"
                        width={250 / 3}
                        height={178 / 3}
                    />
                    {/* Signout Button */}
                    <button
                        type="button"
                        className="absolute top-8 right-6 bg-black/10 p-2 rounded-full transition hover:bg-white/30"
                        onClick={logout}
                    >
                        <Icon className="text-white" size="sm" icon="logout" />
                    </button>

                    <div className="absolute w-full p-4 left-0 top-[60px]">
                        <ul
                            className={classNames(
                                "flex flex-col gap-1 pr-2 text-white",
                                "[&>li]:h-6 [&>li]:flex [&>li]:items-center [&>li]:justify-between",
                            )}
                        >
                            <li>
                                <span>{authTpNm}</span>
                                {userInfo?.usrId}
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {isInitialized && !isSignedIn && userInfo.lgnTp !== "ANY" && (
                <>
                    <img
                        className="absolute top-0 left-0 -translate-y-1/3 translate-x-1/4"
                        src={process.env.PUBLIC_URL + "/imgs/img_airplane.svg"}
                        alt="login background image airplane"
                        title="login background image airplane"
                        width={101 * (3 / 4)}
                        height={107 * (3 / 4)}
                    />
                    <img
                        className="absolute top-0 right-0 -translate-x-[5%] -translate-y-1/4"
                        src={process.env.PUBLIC_URL + "/imgs/img_ship.svg"}
                        alt="login background image ship"
                        title="login background image ship"
                        width={250 * (3 / 4)}
                        height={178 * (3 / 4)}
                    />

                    <div className="absolute bottom-0 left-0 w-full p-4">
                        <div className="flex gap-4">
                            <button
                                type="button"
                                className="flex-1 bg-white border-white rounded border text-primary-text-light h-10"
                                onClick={handleLogin}
                            >
                                {t("L_LGN")}
                            </button>
                            <button
                                type="button"
                                className="flex-1 border border-white text-primary-contrast rounded h-10"
                                onClick={handleRegist}
                            >
                                {t("L_USR_RGSR")}
                            </button>
                        </div>
                        <Button
                            color="primary-contrast"
                            variant="underlined"
                            width="full"
                            onClick={() => {
                                navigate("/findId");
                            }}
                        >
                            Forgot your ID or Password?
                        </Button>
                    </div>
                </>
            )}
            {window.origin.includes("cupia.or.kr") && (
                <div className="absolute p-4 top-[0px] text-error text-lg font-bold">
                    TEST SERVER,
                    <br />
                    KOREA
                </div>
            )}
            {window.origin.includes("dev.tra.go.tz") && (
                <div className="absolute p-4 top-[0px] text-error text-lg font-bold">
                    TEST SERVER,
                    <br />
                    TANZANIA
                </div>
            )}
        </div>
    );
};
